// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DarkTheme__modal-footer___33zUk {
    background-color: var(--steel4);
    color: var(--tertiary);
    border-color: var(--steel4);
  }
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/components/ModalFooter/themes/DarkTheme.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,2BAA2B;EAC7B","sourcesContent":[".DarkTheme__modal-footer___33zUk {\n    background-color: var(--steel4);\n    color: var(--tertiary);\n    border-color: var(--steel4);\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
